import React from 'react';

import { BarTask } from '@interfaces/ganttTasks/barTask';
import {
	GanttContentMoveAction,
	GanttEvent,
} from '@interfaces/ganttTasks/ganttTaskActions';
import { EventOption } from '@interfaces/ganttTasks/ganttTasks';

import { TASKS_WITHOUT_MILESTONES_ROW } from '@components/common/Gantt/constants';

import Arrow from '../../Arrow';
import TaskItem from '../../TaskItem';

export type TaskGanttContentProps = {
	tasks: BarTask[];
	ganttEvent: GanttEvent;
	rowHeight: number;
	taskHeight: number;
	arrowIndent: number;
	setGanttEvent: (value: GanttEvent) => void;
} & EventOption;

const TaskGanttContent: React.FC<TaskGanttContentProps> = ({
	tasks,
	ganttEvent,
	rowHeight,
	taskHeight,
	arrowIndent,
	setGanttEvent,
	onClick,
}) => {
	/**
	 * Method is Start point of task change
	 */
	const handleBarEventStart = async (
		action: GanttContentMoveAction,
		task: BarTask,
		event?: React.MouseEvent | React.KeyboardEvent,
	) => {
		if (!event) {
			return;
		}
		// Mouse Events
		else if (action === 'mouseenter') {
			if (!ganttEvent.action) {
				setGanttEvent({
					action,
					changedTask: task,
					originalSelectedTask: task,
				});
			}
		} else if (action === 'mouseleave') {
			if (ganttEvent.action === 'mouseenter') {
				setGanttEvent({ action: '' });
			}
		} else if (action === 'click') {
			!!onClick && onClick(task);
		} else {
			setGanttEvent({
				action,
				changedTask: task,
				originalSelectedTask: task,
			});
		}
	};

	return (
		<g className='content'>
			<g className='arrows'>
				{tasks.map(task => {
					return task.barLinkedChildren.map(child => {
						const taskTo = tasks[child.linkedBar.index];

						return (
							<Arrow
								key={`Arrow from ${task.id} to ${taskTo.id}`}
								arrowIndent={arrowIndent}
								isActive={child.isActive}
								linkType={child.linkType}
								rowHeight={rowHeight}
								taskFrom={task}
								taskHeight={taskHeight}
								taskTo={taskTo}
							/>
						);
					});
				})}
			</g>
			<g
				className='bar'
				fontSize='14px'
			>
				{tasks.map(task => {
					if (task.id === TASKS_WITHOUT_MILESTONES_ROW) {
						return null;
					}

					return (
						<TaskItem
							key={task.id}
							arrowIndent={arrowIndent}
							onEventStart={handleBarEventStart}
							task={task}
							taskHeight={taskHeight}
						/>
					);
				})}
			</g>
		</g>
	);
};

export default TaskGanttContent;
